module.exports = __webpack_public_path__ + "public/images/slider/loseva-circle.a7d9cb79aefb3bed83e4fe4463687ccf.webp";